'use client';

import { signOutAction } from '../../auth/actions';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

export default function LogoutButton() {
    const router = useRouter();
    const [isPending, setIsPending] = useState(false);

    async function handleLogout() {
        setIsPending(true);
        try {
            await signOutAction();
            // La redirección ocurre automáticamente desde el servidor
        } catch (error) {
            console.error('Error al cerrar sesión:', error);
        } finally {
            setIsPending(false);
        }
    }

    return (
        <button
            onClick={handleLogout}
            disabled={isPending}
            className="text-sm font-medium text-red-600 hover:text-red-500 disabled:opacity-50 transition-colors"
        >
            {isPending ? 'Cerrando sesión...' : 'Cerrar sesión'}
        </button>
    );
}
